import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../components/snackbar/snackbar.component';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  constructor(private snackbar: MatSnackBar) { }

  show(message: string, duration: number = 1500) {
    this.snackbar.openFromComponent(SnackbarComponent, {
      duration: duration,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['snackbar-success'],
      data: {message: message, snackType: 'success'}
    });
  }

  error(message: string, duration: number = 5000) {
    this.snackbar.openFromComponent(SnackbarComponent, {
      duration: duration, 
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['snackbar-error'],
      data: {message: message, snackType: 'error'}
    });
  }

  info(message: string, duration: number = 5000) {
    this.snackbar.openFromComponent(SnackbarComponent, {
      duration: duration,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['snackbar-info'],
      data: { message: message, snackType: 'info' }
    });
  }

  confirm(message: string, action: string) {
    this.snackbar.openFromComponent(SnackbarComponent, {
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['snackbar-confirm'],
      data: { message: message, snackType: 'confirm', action: action }
    });
  }

  warning(message: string, duration: number = 5000) {
    this.snackbar.openFromComponent(SnackbarComponent, {
      duration: duration,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['snackbar-warning'],
      data: { message: message, snackType: 'warning' }
    });
  }

  versionUpdate(message: string) {
    this.snackbar.openFromComponent(SnackbarComponent, {
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['snackbar-version-update'],  
      data: { message: message, refresh: true, snackType: 'version-update'}
    }).onAction().subscribe(() => {
      window.location.reload();
    })
  }

  tip(message: string, duration: number = 8000) {
    this.snackbar.openFromComponent(SnackbarComponent, {
      duration: duration,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['snackbar-info'],
      data: { message: message, snackType: 'info'}
    });
  }

}
